import { render } from "./vorderbelong.vue?vue&type=template&id=2232b5fe&scoped=true"
import script from "./vorderbelong.vue?vue&type=script&lang=js"
export * from "./vorderbelong.vue?vue&type=script&lang=js"

import "./vorderbelong.vue?vue&type=style&index=0&id=2232b5fe&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2232b5fe"]])

export default __exports__